// These functions create an <iframe> (and YouTube player)
// after the API code downloads and loads the video from the data attributes.
var player,
    counter = 0;
window.onYouTubeIframeAPIReady = function() {
  $('.wex-video_player').each(function(index, el){
    counter++;
    var playerContainer = 'videoPlayer' + counter;
    $(this).attr('id', playerContainer);
    setupYTPlayer(el, playerContainer);
  });
  
};

var vids = [];
function setupYTPlayer(el, playerContainer) {
  var playerHeight = $(el).data('height'),
      playerWidth = $(el).data('width'),
      videoId = $(el).data('embed-id');

  player = new YT.Player(playerContainer, {
    height: playerHeight,
    width: playerWidth,
    videoId: videoId,
    playerVars: {
      'showinfo': 0,
      'autohide': 1,
      'rel': 0,
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange,
    }
  });

  vids.push(player);

}


// The API will call this function when the video player is ready.
function onPlayerReady(event) {
  var videoOverlay = event.target.a.nextElementSibling;
  var modalOverlay = $('.wex-modal-thumb[data-open="'+$($(event.target.a).closest('.wex-modal').get(0)).attr('id')+'"]');

  $(videoOverlay).on('click', function(){
    event.target.playVideo();
  });

  if(modalOverlay.length !== 0) {
    var modal = $(event.target.a).closest('.wex-modal').get(0);
    $(modalOverlay).on('click', function(){
      event.target.playVideo();
    });

    $(modal).on('closed.zf.reveal', function(){
      event.target.stopVideo();
    });
  }
}

// The API calls this function when the player's state changes.
// The function indicates that when playing a video (state=1),
// the player should play for six seconds and then stop.
var done = false;
// var playerCurrentlyPlaying = null;

function onPlayerStateChange(event) {
  var videoOverlay = event.target.a.nextElementSibling,
      playerId = $(event.target.a).attr('id');

  if (event.data == YT.PlayerState.PLAYING && !done) {
    $(videoOverlay).hide();
  }

  if (event.data == YT.PlayerState.PLAYING) {
    stopVideo(playerId);
  }
}

// Stop other videos on the page if they aren't the one currently picked to play
function stopVideo(player_id) {
  for(var i=0;i<vids.length;i++){
    if (player_id !=vids[i].a.id) {
      vids[i].stopVideo();
    }
  }
}